/** Tracer name used when creating OTEL tracers in this SDK. */
export const TRACER_NAME = 'frisk_js_sdk'
/** SDK tracer semantic version. */
export const TRACER_VERSION = '0.1.0'
/** Span name used for policy evaluation around a single tool call. */
export const SPAN_NAME_DECIDE_TOOL_CALL = 'frisk.tool_call.decide'

export const SPAN_NAME_OBSERVE_TOOL_CALL = 'frisk.tool_call.observation'

/** Span name used for a single LLM invocation within a session. */
export const SPAN_NAME_LLM_CALL = 'frisk.llm_call'

/** Span name used for a single operation (e.g. a LangChain run) within a session. */
export const SPAN_NAME_OPERATION = 'frisk.operation'

/** Span name used for the parent Frisk session lifecycle span. */
export const SPAN_NAME_FRISK_SESSION = 'frisk.session'

/** Tool-call span attribute linking back to the LLM call that announced it. */
export const ATTRIBUTE_NAME_LLM_CALL_SPAN_ID =
  'frisk.tool_call.llm_call_span_id'
/** LLM call span attribute holding the single prompt string. */
export const ATTRIBUTE_NAME_LLM_CALL_PROMPT = 'frisk.llm_call.prompt'
/** LLM call span attribute holding the JSON-stringified prompt messages. */
export const ATTRIBUTE_NAME_LLM_CALL_PROMPTS_JSON =
  'frisk.llm_call.prompts.json'
/** LLM call span attribute holding the JSON-stringified responses. */
export const ATTRIBUTE_NAME_LLM_CALL_RESPONSES_JSON =
  'frisk.llm_call.responses.json'
/** LLM call span attribute holding the JSON-stringified requested tool calls. */
export const ATTRIBUTE_NAME_LLM_CALL_TOOL_CALLS_JSON =
  'frisk.llm_call.tool_calls.json'

/** LLM call span attribute for the model name. */
export const ATTRIBUTE_NAME_MODEL_NAME = 'frisk.model.name'
/** LLM call span attribute for the model provider. */
export const ATTRIBUTE_NAME_MODEL_PROVIDER = 'frisk.model.provider'
/** LLM call span attribute for input (prompt) token count. */
export const ATTRIBUTE_NAME_TOKEN_USAGE_INPUT_TOKENS =
  'frisk.token_usage.input_tokens'
/** LLM call span attribute for output (completion) token count. */
export const ATTRIBUTE_NAME_TOKEN_USAGE_OUTPUT_TOKENS =
  'frisk.token_usage.output_tokens'
/** LLM call span attribute for total token count. */
export const ATTRIBUTE_NAME_TOKEN_USAGE_TOTAL_TOKENS =
  'frisk.token_usage.total_tokens'

export const ATTRIBUTE_NAME_SESSION_PROMPT = 'frisk.session.prompt'
export const ATTRIBUTE_NAME_SESSION_ID = 'frisk.session.id'
export const ATTRIBUTE_NAME_REMOTE_SESSION_ID = 'frisk.session.remote_id'

/** Span attribute key for captured LLM reasoning metadata. */
export const ATTRIBUTE_NAME_LLM_REASONING = 'frisk.llm_reasoning'
export const ATTRIBUTE_NAME_TOOL_NAME = 'frisk.tool.name'
export const ATTRIBUTE_NAME_FRISK_TOOL_ID = 'frisk.tool.id'
export const ATTRIBUTE_NAME_FRISK_TOOL_VERSION_ID = 'frisk.tool.version_id'
export const ATTRIBUTE_NAME_TOOL_CALL_ID = 'frisk.tool_call.id'
export const ATTRIBUTE_NAME_TOOL_ARGS_JSON = 'frisk.tool.args.json'
export const ATTRIBUTE_NAME_TOOL_ARGS_REDACTED_PATHS_JSON =
  'frisk.tool.args_redacted_paths.json'
export const ATTRIBUTE_NAME_AGENT_STATE_JSON = 'frisk.agent_state.json'
export const ATTRIBUTE_NAME_AGENT_STATE_REDACTED_PATHS_JSON =
  'frisk.agent_state_redacted_paths.json'
export const ATTRIBUTE_NAME_DECISION_MATCHED_RULE_COUNT =
  'frisk.decision.matched_rule_count'
export const ATTRIBUTE_NAME_DECISION_OUTCOME = 'frisk.decision.outcome'
export const ATTRIBUTE_NAME_DECISION_REASON = 'frisk.decision.reason'
export const ATTRIBUTE_NAME_ERROR_TYPE = 'error.type'
export const ATTRIBUTE_NAME_ERROR_MESSAGE = 'error.message'
export const ATTRIBUTE_NAME_TOOL_CALL_IS_SUCCESS = 'frisk.tool_call.is_success'
export const ATTRIBUTE_NAME_TOOL_CALL_IS_ERROR = 'frisk.tool_call.is_error'
export const ATTRIBUTE_NAME_TOOL_CALL_COUNT = 'frisk.tool_calls.count'
export const ATTRIBUTE_NAME_TOOL_CALL_ERROR_COUNT =
  'frisk.tool_calls.error_count'
export const ATTRIBUTE_NAME_TOOL_CALL_SEQUENCE_NUMBER =
  'frisk.tool_call.sequence_number'
